import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "linkedin"
const LinkedinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.275 8.827V20H5.076V8.827zM16.3 8.587C18.4 8.587 20 10.107 20 13.414V20H16.775V13.813C16.775 12.374 16.325 11.387 15.15 11.387 14.275 11.386 13.75 12.053 13.5 12.693 13.425 12.933 13.4 13.253 13.4 13.573V20H10.2V12.4C10.2 11.014 10.151 9.84 10.126 8.827H12.9L13.05 10.4H13.1C13.527 9.654 14.576 8.587 16.3 8.587M6.701 4C7.726 4 8.375 4.747 8.375 5.733 8.4 6.693 7.725 7.466 6.65 7.466 5.65 7.466 5 6.693 5 5.733 5 4.747 5.676 4 6.701 4" />
        </svg>
      }
    </span>
  )
}
export default LinkedinIcon
